import { useContext } from "react";
import ReportShowAllCheckbox from "components/ReportShowAllCheckbox";
import { TrendReportContext } from "contexts/TrendReportContext/TrendReportContext";

const TopFiveFailureCodesCheckbox = () => {
    const {
        showAllFailureCodes,
        selectedFailureCode,
        selectedPreviousFailureCode,
        handleShowAllFailureCodesChange,
        handleSetSelectedFailureCode,
        handleSelectedPreviousFailureCodeChange,
    } = useContext(TrendReportContext);

    return (
        <ReportShowAllCheckbox
            checked={showAllFailureCodes}
            onChange={(_, checked) => {
                handleShowAllFailureCodesChange(checked);
                if (checked) {
                    handleSelectedPreviousFailureCodeChange(selectedFailureCode);
                    handleSetSelectedFailureCode(undefined);
                } else {
                    handleSetSelectedFailureCode(selectedPreviousFailureCode);
                }
            }}
        />
    );
};

export default TopFiveFailureCodesCheckbox;
